import React, { useState } from 'react';
import { Card, Form, Input, Select, Button, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import AdminUserService from "../../../../services/AdminUserService";

const { Option } = Select;

const CreateUser = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const userData = {
                username: values.username,
                fullName: values.fullName,
                iin: values.iin,
                phone: values.phone,
                email: values.email,
                registrationAddress: values.registrationAddress,
                residenceAddress: values.residenceAddress,
                businessType: values.businessType,
                password: values.password,
            };

            await AdminUserService.createUser(userData);

            message.success(<IntlMessage id={'dashboard.admin.createUser.success'} fallback={'Пользователь успешно создан'} />);
            form.resetFields();
        } catch (error) {
            console.error('Error creating user:', error);
            message.error(<IntlMessage id={'dashboard.admin.createUser.error'} fallback={'Не удалось создать пользователя'} />);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card 
            title={
                <>
                    <PlusOutlined style={{ marginRight: 8 }} />
                    <IntlMessage id={'dashboard.admin.createUser.title'} fallback={'Создать нового пользователя'} />
                </>
            }
            style={{ height: '100%' }}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    name="username"
                    label={<IntlMessage id={'username'} fallback={'Имя пользователя'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder="Введите имя пользователя" />
                </Form.Item>

                <Form.Item
                    name="fullName"
                    label={<IntlMessage id={'fullName'} fallback={'ФИО'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder="Введите полное имя согласно документам" />
                </Form.Item>

                <Form.Item
                    name="iin"
                    label={<IntlMessage id={'iin'} fallback={'ИИН'} />}
                    rules={[
                        { required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> },
                        { len: 12, message: 'ИИН должен содержать 12 цифр' }
                    ]}
                >
                    <Input placeholder="Введите индивидуальный идентификационный номер" maxLength={12} />
                </Form.Item>

                <Form.Item
                    name="phone"
                    label={<IntlMessage id={'phone'} fallback={'Контактный телефон'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder="+7 (XXX) XXX-XX-XX" />
                </Form.Item>

                <Form.Item
                    name="email"
                    label={<IntlMessage id={'email'} fallback={'Email'} />}
                    rules={[
                        { required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> },
                        { type: 'email', message: 'Введите корректный email адрес' }
                    ]}
                >
                    <Input placeholder="example@mail.com" />
                </Form.Item>

                <Form.Item
                    name="registrationAddress"
                    label={<IntlMessage id={'registrationAddress'} fallback={'Адрес регистрации'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder="Введите адрес регистрации" />
                </Form.Item>

                <Form.Item
                    name="residenceAddress"
                    label={<IntlMessage id={'residenceAddress'} fallback={'Адрес фактического проживания'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Input placeholder="Введите адрес фактического проживания" />
                </Form.Item>

                <Form.Item
                    name="businessType"
                    label={<IntlMessage id={'businessType'} fallback={'Тип хозяйства'} />}
                    rules={[{ required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> }]}
                >
                    <Select placeholder="Выберите тип хозяйства">
                        <Option value="IP">ИП (Индивидуальный предприниматель)</Option>
                        <Option value="KH">КХ (Крестьянское хозяйство)</Option>
                        <Option value="TOO">ТОО (Товарищество с ограниченной ответственностью)</Option>
                        <Option value="PK">ПК (Производственный кооператив)</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="password"
                    label={<IntlMessage id={'password'} fallback={'Пароль для входа'} />}
                    rules={[
                        { required: true, message: <IntlMessage id={'requiredField'} fallback={'Обязательное поле'} /> },
                        { min: 6, message: 'Пароль должен содержать минимум 6 символов' }
                    ]}
                >
                    <Input.Password placeholder="Введите пароль" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        <IntlMessage id={'dashboard.admin.createUser.submit'} fallback={'Создать пользователя'} />
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default CreateUser;